<template>
    <div>
        <div class="form-row mb-3 d-flex">
                        <div class="col-10">
                            <input type="text" class=" form-control-lg form-control" placeholder="Say Something" v-model="newMessage" @keyup.enter="create()" @keyup ="showerror= false">
                        </div>
                        <div class="col-2">
                            <button class="btn btn-primary btn-lg w-100" @click="create()">
                                <i class="icofont-plus-circle"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-12">
                        <small class="text-danger" v-if="showerror">{{errormessage}}</small>
                    </div>
    
    </div>
</template>

<script>
    export default {
        name : 'Form',
        data() {
            return {
                newMessage: "",
                errormessage : "",
                showerror : false
            }
        },
        methods: {
            create() {
                if(this.newMessage.length){
                    this.$emit("create",this.newMessage);
                     this.newMessage =""
                }
                else{
                    this.showerror = true,
                    this.errormessage = "say something"
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>